import { render } from "./AccountServiceProduct.vue?vue&type=template&id=83511b8e&scoped=true"
import script from "./AccountServiceProduct.vue?vue&type=script&steup=true&lang=js"
export * from "./AccountServiceProduct.vue?vue&type=script&steup=true&lang=js"

import "./AccountServiceProduct.vue?vue&type=style&index=0&id=83511b8e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83511b8e"]])

export default __exports__